// core
import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
// services
import { PartnerBrandService } from '@campfire-nx/api';
import { RaptorStepService } from '../../services/raptor-step.service';
import { RaptorPaymentService } from '../../services/raptor-payment.service';
import { RaptorStepDataService } from '../../services/raptor-step-data.service';
import { RaptorAnalyticsService } from '../../services/raptor-analytics.service';

@Component({
  selector: 'open-raptor-gocardless-form',
  templateUrl: './raptor-gocardless-form.component.html',
  styleUrls: ['./raptor-gocardless-form.component.scss']
})
export class RaptorGocardlessFormComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() question!: any;
  @Input() option!: any;

  test = false;
  loading: boolean = false;
  ddname: any;
  ddbsb: any;
  ddaccnum: any;
  account: any = {};
  partnerName!: string;
  supportPhone!: string;
  pdsLink!: string;

  constructor(
    public raptorStepService: RaptorStepService,
    public raptorPaymentService: RaptorPaymentService,
    private partnerBrandService: PartnerBrandService,
    private raptorStepDataService: RaptorStepDataService,
    private raptorAnalyticsService: RaptorAnalyticsService,
    @Inject('environment') public environment: any
  ) { }

  ngOnInit(): void {
    this.ddname = { key: `${this.question.key}.${this.option.service}.ddname` };
    this.ddbsb = { key: `${this.question.key}.${this.option.service}.ddbsb` };
    this.ddaccnum = { key: `${this.question.key}.${this.option.service}.ddaccnum` };
    this.loading = true;
    this.raptorPaymentService.loadGocardless(this.option);
    this.partnerName = this.partnerBrandService.getAttribute('name', 'partner');
    this.supportPhone = this.partnerBrandService.getAttribute('companyInfo', 'partner')?.SUPPORT_PHONE;

    this.getPdsLink();
  }

  public getCurrentDate(){
    return new Date();
  }

  public changeAccountDetails() {
    this.raptorPaymentService.gocardlessShowAccount = false;
    this.raptorPaymentService.submitLabel = this.option.pre_submit_label;
  }

  private getPdsLink() {
    const formData = this.raptorStepDataService.get();
    const covers = formData.covers;

    if (covers) {
      covers.forEach((cover: any) => {
        const pds = cover.pds?.find((pds: any) => pds.type === 'pds');
        this.pdsLink = pds?.url;
      });
    }
  }

  openPdsDocument(url: string) {
    if (url) {
      this.raptorAnalyticsService.trackAdditionalEvents('view-pds', 'pds');
      window.open(`${this.environment.apiEndpoint}${url}`, '_blank');
    }
  }
}
